import { MutationTree } from 'vuex';
import { IProgress } from '@/dealroom/add-page/import-progress/types/progress';
import { EImportType } from '@/dealroom/add-page/import-progress/types/enums/import-type';
import { EImportProgressMutation } from '@/dealroom/add-page/import-progress/store/import-progress.constants';
import { IImportProgressState } from '@/dealroom/add-page/import-progress/store/import-progress.types';

export const mutations: MutationTree<IImportProgressState> = {
  [EImportProgressMutation.SetInitialized](
    state: IImportProgressState,
    { name, type, index }: { name: string; type: EImportType; index: number }
  ) {
    state.importIndex = index;
    state.name = name;
    state.type = type;
  },
  [EImportProgressMutation.SetProgress](state: IImportProgressState, payload: IProgress) {
    state.progress = payload;
  },
  [EImportProgressMutation.SetState](state: IImportProgressState, payload: IImportProgressState) {
    state.error = payload.error;
    state.importIndex = payload.importIndex;
    state.name = payload.name;
    state.progress = payload.progress;
    state.type = payload.type;
  },
};
